import PreferencesStore from 'types/Preferences';

import api from 'utils/api';

export const getPreferences = () => api.get<PreferencesStore>('/user/dc2preferences');

export const updatePreferences = (preferences: PreferencesStore) => api.put('/user/dc2preferences', preferences);
